<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="500" persistent>
    <v-card rounded="xl">
      <v-card-title class="text-h6 font-weight-bold pt-5 px-6">
        Nota de Crédito
      </v-card-title>
      <v-card-text class="px-6">
        <p class="body-2 mb-4">
          Se emitirá una nota de crédito (CFDI de Egreso) vinculada a la factura de esta orden.
        </p>
        <v-form ref="form" v-model="formValid">
          <v-textarea
            v-model="reason"
            label="Motivo *"
            filled rounded dense
            rows="3"
            :rules="[v => !!v || 'El motivo es requerido']"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text rounded color="grey darken-1" @click="close" :disabled="loading">
          Cancelar
        </v-btn>
        <v-btn
          color="orange darken-1"
          rounded
          class="white--text font-weight-bold"
          @click="submit"
          :loading="loading"
          :disabled="!formValid"
        >
          Emitir Nota de Crédito
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Endpoints from "@/share/Endpoints";
import { mapMutations } from "vuex";

export default {
  props: {
    value: { type: Boolean, default: false },
    order: { type: Object, default: null },
  },
  data: () => ({
    formValid: false,
    loading: false,
    reason: "",
  }),
  watch: {
    value(open) {
      if (open) {
        this.reason = "";
      }
    },
  },
  methods: {
    ...mapMutations("notification", ["show"]),
    close() {
      this.$emit("input", false);
    },
    async submit() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        const url = Endpoints.invoicesOrderCreditNote.replace(/:orderId/, this.order.id);
        const { data } = await this.axios.post(url, { reason: this.reason });
        this.show({ text: data.message || "Nota de crédito emitida exitosamente", color: "success", time: 3000 });
        this.$emit("credited");
        this.close();
      } catch (error) {
        const msg = error.response?.data?.error?.message || "Error al emitir la nota de crédito";
        this.show({ text: msg, color: "error", time: 4000 });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
